import { useWorkflowStore } from '@bv/components/workflow/store/workflow';

import type { StepConfig } from '../../types/workflow';

const getAvailableNodesForSelection = () => {
  const store = useWorkflowStore();
  const steps = store.getAvailableNodesForSelection(store.selectedNodeId! as string);
  return steps;
};

const jump: StepConfig = {
  // Design
  icon: 'jump',
  headerTextColor: '#2580BE',
  headerColor: '#D6E6F1',
  title: 'Jump',
  text: 'Jump',
  category: 'Node',
  desc: 'Allows a contact to jump to a specific step in this workflow. Once the maximum number of jumps is reached, the contact will proceed to the next step.',
  primaryKey: 'nodeId',
  // Connector configuration

  // Form
  formFields: [
    {
      key: 'nodeId',
      label: 'Jump To',
      type: 'select',
      placeholder: 'Select destination step',
      options: () => {
        return getAvailableNodesForSelection();
      },
      validation: { required: true },
    },
    {
      key: 'maxJumps',
      label: 'Jump Times',
      type: 'number',
      placeholder: 'Enter number of allowed jumps',
      defaultValue: null,
      validation: {
        required: true,
        minValue: 1,
        maxValue: 10,
        numeric: true,
        integer: true,
      },
    },
  ],
};

export default jump;
